import React from 'react';
import {
  Section as StatelySection,
  SectionProps as StatelySectionProps,
} from 'react-stately';

export type ListBoxSectionProps<T extends object> = StatelySectionProps<T>;

/*
 * HACK
 *
 * This component just redefines react-stately's `Section` component.
 *
 * `react-aria` builds collections using `react-stately`'s collection API, which
 * involves the `Section` component.  The `Sections` component behaves a bit differntly
 * than most components as it doesn't really render anything and defines a publicly
 * accessible function that the react-stately library calls.
 *
 * Because of this function that exists on the component, wrapping `Section` in a
 * custom component won't work since the static function will be missing.  `Section`
 * does, however, pass all props through to the underlying component, so just updating
 * the types for the `Section` component will make TS happy
 */
export const ListBoxSection = StatelySection as <T extends object>(
  props: ListBoxSectionProps<T>,
) => React.ReactElement | null;

export default ListBoxSection;
